import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngxs/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthUser } from "~app/core/auth/core/auth-user.model";
import { AuthState } from "~app/core/auth/core/auth.state";
import { SubscriptionState } from "../store/subscription";
import {
  LoadMemberId,
  LoadSubscriptionPeriods,
  LoadSubscriptionStatus,
  SeeParticularConditions,
  SeeSubscriptionReceipt,
} from "../store/subscription/subscription.actions";
import {
  MemberInsuranceViewModel,
  SubscriptionPeriod,
  SubscriptionReceipt,
} from "../store/subscription/subscription.model";

@Component({
    selector: "odq-subscription-period-selection",
    templateUrl: "./subscription-period-selection.component.html",
    styleUrls: ["./subscription-period-selection.component.scss"],
    standalone: false
})
export class SubscriptionPeriodSelectionComponent implements OnInit, OnDestroy {
  user: AuthUser;
  private destroy$ = new Subject<void>();
  user$ = this.store.select<AuthUser>(AuthState.user);
  periods$ = this.store.select<SubscriptionPeriod[]>(SubscriptionState.periods);
  loadingMemberId$ = this.store.select<boolean>(
    SubscriptionState.loadingMemberId
  );
  loadingPeriods$ = this.store.select<boolean>(
    SubscriptionState.loadingPeriods
  );
  loadingReport$ = this.store.select<boolean>(SubscriptionState.loadingReport);
  isSubscriptionBlocked$ = this.store.select<boolean>(
    SubscriptionState.isSubscriptionBlocked
  );
  memberId$ = this.store.select<string>(SubscriptionState.memberId);
  memberId: string;

  memberStatus$ = this.store.select<MemberInsuranceViewModel[]>(
    SubscriptionState.souscriptionStatus
  );
  userCanEditForm$ = this.store.select<boolean>(
    SubscriptionState.userCanEditForm
  );
  inactiveMemberForSubscription$ = this.store.select<boolean>(
    AuthState.inactiveMemberForSubscription
  );

  isInscriptionStatusActive: boolean;
  isExerciseStatusActive: boolean;
  isExemptFromInsurance: boolean;
  isWaitingForInsurance: boolean;
  userCanEditForm: boolean;

  constructor(
    private store: Store,
    private router: Router,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.user$.pipe(takeUntil(this.destroy$)).subscribe((u) => {
      if (u) {
        this.user = u;
        this.store.dispatch(new LoadMemberId(u.permitNumber));
      }
    });
    this.memberId$.pipe(takeUntil(this.destroy$)).subscribe((m) => {
      if (m) {
        this.memberId = m;
        this.store.dispatch(new LoadSubscriptionPeriods(m));
        this.store.dispatch(new LoadSubscriptionStatus(m));
      }
    });
    this.memberStatus$.pipe(takeUntil(this.destroy$)).subscribe((s) => {
      if (!!s && s.length > 0) {
        this.isInscriptionStatusActive = s[0]?.isActiveInscription;
        this.isExerciseStatusActive = s[0]?.isActiveExercise;
        this.isExemptFromInsurance = s[0]?.isExemptFromInsurance;
        this.isWaitingForInsurance = s[0]?.isWaitingForInsurance;
      }
    });
    this.userCanEditForm$.pipe(takeUntil(this.destroy$)).subscribe((p) => {
      this.userCanEditForm = p;
    });
  }

  fillForm(period: SubscriptionPeriod) {
    if (period.subscriptionNoticeId) {
      this.router.navigateByUrl(
        "/farp-subscription/notice/" + period.subscriptionNoticeId
      );
    } else {
      this.router.navigateByUrl("/farp-subscription/form/" + period.year);
    }
  }
  showReportParticularConditions(period: SubscriptionPeriod) {
    this.store.dispatch(
      new SeeParticularConditions(
        this.memberId,
        period.year,
        this.user.permitNumber
      )
    );
  }

  showReceipt(receipt: SubscriptionReceipt) {
    this.store.dispatch(
      new SeeSubscriptionReceipt(
        this.memberId,
        receipt.id,
        receipt.description,
        this.user.permitNumber
      )
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
